import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import "./ManetBlogs.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const ManetBlog = () => {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");

  useEffect(() => {
    fetchYears();
    fetchBlogs("");
  }, []);

  const fetchYears = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/admin/manet-blogs/public/years`);
      const data = await res.json();
      if (data.success) setYears(data.data.map((y) => y.year));
    } catch (err) {
      console.log(err);
    }
  };

  const fetchBlogs = async (year) => {
    try {
      const url = year
        ? `${API_BASE}/api/admin/manet-blogs/public?year=${year}&t=${Date.now()}`
        : `${API_BASE}/api/admin/manet-blogs/public?t=${Date.now()}`;

      const res = await fetch(url, { cache: 'no-store' });
      const data = await res.json();

      if (data.success) {
        setBlogs(data.data);
      } else {
        console.warn('Failed to fetch blogs');
      }
    } catch (err) {
      console.error('Blogs fetch error:', err);
    }
  };


  const handleYearChange = (e) => {
    const year = e.target.value;
    console.log("Year changed to:", year);
    setSelectedYear(year);
    fetchBlogs(year || null);
  };

  return (
    <div>
      {/* HEADER */}
      <div className="gallery-header">
        <h1 className="title">MANET Blogs</h1>

        <div className="selectedYear">
          <label className="year-title">Select Year: </label>
          <select
            className="selectyear"
            value={selectedYear}
            onChange={handleYearChange}
          >
            <option value="">All Years</option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="blog-list">
        {blogs.length === 0 ? (
          <div>
            <p>No approved blogs available for {selectedYear || "any year"}.</p>
            <p>Please check the admin panel to approve some blogs.</p>
          </div>
        ) : (
          blogs.map((blog) => (
            <div
              className="blog-card"
              key={blog.id}
              onClick={() => navigate(`/lifeatcampus/manet-blogs/${blog.id}`)}
            >
              <div className="blog-top">
                <h3 className="innerpage-heading" >{blog.title}</h3>
                <h2 className="blog-subtitle">
                  By {blog.blog_by}
                  {blog.blog_date && ` | ${new Date(blog.blog_date).toLocaleDateString()}`}
                </h2>
              </div>

              <div className="blog-card-content">
                {blog.blog_image && (
                  <img
                    src={`${API_BASE}${blog.blog_image}`}
                    alt={blog.title}
                    className="blog-image"
                  />
                )}

                <p>
                  {blog.message.length > 200
                    ? blog.message.slice(0, 1000) + "..."
                    : blog.message}
                  <button
                    className="blog-btn"
                    onClick={() =>
                      navigate(`/lifeatcampus/manet-blogs/${blog.id}`)
                    }
                  >
                    Read More →
                  </button>
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ManetBlog;
